

const CSV_PATH = 'config/csv/';
/**
 * csv文件类
 */
export namespace CsvFileKind {

    /** 通用数值 */  
    export enum GeneralValue {
        CSV_TITLE = 'title',
    }
    
    /**
     * csv 文件
     */
    export const CsvFile = {
        /** 等级 */
        LEVEL: CSV_PATH + 'level/level',

        /** 任务 */
        TASK_LIST: CSV_PATH + 'task/task_list',

        /** 第一次进入界面表 */
        FIRST_ENTER_LAYER: CSV_PATH + 'event/first_enter_layer',
        /** 第一次进入界面触发的事件表 */
        FIRST_ENTER_EVENT: CSV_PATH + 'event/first_enter_event',
        /** 固定时间事件组 */
        FIXED_TIME_EVENT_ARR: CSV_PATH + 'event/fixed_time_event_arr',
        /** 固定时间事件 */
        FIXED_TIME_EVENT: CSV_PATH + 'event/fixed_time_event',
        /** 随机事件组 */
        RANDOM_EVENT_ARR: CSV_PATH + 'event/random_event_arr',
        /** 随机事件 */
        RANDOM_EVENT: CSV_PATH + 'event/random_event',
        /** 主剧情事件组 */
        MAIN_EVENT_ARRAY: CSV_PATH + 'event/main_event_array',
        /** 主剧情事件 */
        MAIN_EVENT: CSV_PATH + 'event/main_event',
        /**官员升级事件 */
        UPGRADE_EVENT:CSV_PATH + 'event/upgrade_event',
        /**官员升级事件组 */
        UPGRADE_EVENT_ARR:CSV_PATH + 'event/upgrade_event_arr',
        

        /** 案件配置 */
        LEGAL_CASE_CONFIG: CSV_PATH + 'settleLawsuit/legal_case_config',
        /** 案件人物表 */
        LEGAL_CASE_PEOPLE: CSV_PATH + 'settleLawsuit/legal_case_people',
        /** 案件人物组表 */
        LEGAL_CASE_PEOPLE_ARRAY: CSV_PATH + 'settleLawsuit/legal_case_people_array',

        /** 初级案件 */
        LEGAL_CASE_PRIMARY: CSV_PATH + 'settleLawsuit/primary/legal_case_primary',
        /** 初级案件步骤表 */
        LEGAL_CASE_PRIMARY_STEP: CSV_PATH + 'settleLawsuit/primary/legal_case_primary_step',
        /** 初级案件证物表 */
        LEGAL_CASE_PRIMARY_EXHIBIT: CSV_PATH + 'settleLawsuit/primary/legal_case_primary_exhibit',
        /** 初级案件动作表 */
        LEGAL_CASE_PRIMARY_ACTION: CSV_PATH + 'settleLawsuit/primary/legal_case_primary_action',


        /** 特殊案件 */
        LEGAL_CASE_SPECIAL: CSV_PATH + 'settleLawsuit/special/legal_case_special',
        
        /** 案件主要 */
        LEGAL_CASE_MAIN: CSV_PATH + 'settleLawsuit/main/legal_case_main',
        /** 案件主要模式属性 */
        LEGAL_CASE_MAIN_ATTRIBUTE: CSV_PATH + 'settleLawsuit/main/legal_case_main_attribute',

        /** 升官考试题目库 */
        EXAM_QUESTION_BANK: CSV_PATH + 'promoteLevel/exam_question_bank',


        /** 
         * 军事
         */
        /** 城池 */
        CITY: CSV_PATH + 'military/city',
        /** 军官 */
        OFFICER: CSV_PATH + 'military/officer',

        /** 典当
         * 
         */
        PAWN: CSV_PATH + 'pawn/pawn',

        /** 比武招亲 */
        MATCH_MIAI: CSV_PATH + 'matchMiai/matchMiai',

        /** 押镖1 */
        ESCORT_GOODS1: CSV_PATH + 'escortGoods/escortGoods1',

        /** 时空关卡 */
        THRU_TIME_LEVEL: CSV_PATH + 'thruTime/thru_time_level',


        /** 府邸 */
        MANSION: CSV_PATH + 'mansion/mansion',
        /** 府邸建筑 */
        MANSION_BUILD: CSV_PATH + 'mansion/mansion_build',
        /** 儿女亲密度 */
        CHILD_INTIMACY: CSV_PATH + 'mansion/child_intimacy',
        /** 妻子亲密度 */
        WIFE_INTIMACY: CSV_PATH + 'mansion/wife_intimacy',
        /** 妻子 */
        WIFE: CSV_PATH + 'mansion/wife',
        /** 卡牌 */
        MANSION_CARD: CSV_PATH + 'mansion/mansion_card',
        /** 船 */
        SHIP: CSV_PATH + 'ship/ship',
        /** 果园 */
        ORCHARD: CSV_PATH + 'orchard/orchard',
    }

}